import styled from "styled-components";

export const Body = styled.div`
  height: 65vh;
  overflow-y: scroll;
`;